const getParentNode = data => {
  return data?.parentNode
}
const getChildNodes = data => {
  return data?.childNodes
}

export {getParentNode, getChildNodes}
